import lodash from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBailiffDialogOptionSpeaker } from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
import { bailiffDialogAllSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
//
//component
//redux
//selector
//actions
export const TriggerSpeaker = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const dialogs = useSelector(bailiffDialogAllSelector);
  const sorted = lodash.orderBy(dialogs, "slot", "asc");
  const mapped =
    sorted?.map((s) => {
      const sentences = s?.sentences?.map((se) => ({ ...se, id: s?.id })) || [];
      return sentences;
    }) || [];
  const flatten = lodash.flatten(mapped) || [];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const speaker = flatten?.map((f) => f?.speaker) || [];
  const uniq = lodash.uniq(speaker);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (uniq) {
      dispatch(setBailiffDialogOptionSpeaker(uniq));
    }
  }, [uniq, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerSpeaker;
